import axios from 'axios';

const API_URL = 'https://zebrastore-api.onrender.com/api';

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

// Request interceptor to add token to all requests
api.interceptors.request.use(
    config => {
        // Check for both user and admin tokens
        const userToken = localStorage.getItem('token');
        const adminToken = localStorage.getItem('admin_token');

        // Use admin token for admin routes, user token for others
        const token = config.url.includes('/admin/') ? adminToken : userToken;

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle token expiration
api.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            // Clear authentication data based on route
            if (error.config.url.includes('/admin/')) {
                localStorage.removeItem('admin_token');
            } else {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
            }
        }
        return Promise.reject(error);
    }
);

export default api;

// User auth functions
export const login = async (credentials) => {
    try {
        console.log('Attempting user login with:', credentials);
        const response = await api.post('/login', credentials);
        console.log('User login response:', response.data);
        return response.data;
    } catch (error) {
        console.error('User login error details:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status
        });
        throw error;
    }
};


export const register = (userData) => {
    return api.post('/register', userData);
};

// Admin auth functions
export const adminLogin = async (credentials) => {
    try {
        console.log('Attempting admin login with:', credentials);
        const response = await api.post('/admin/login', credentials);
        console.log('Admin login response:', response.data);

        if (response.data.token) {
            localStorage.setItem('admin_token', response.data.token);
            console.log('Token saved in API service');
        }

        return response.data;
    } catch (error) {
        console.error('Admin login error details:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status
        });
        throw error;
    }
};


// Product functions
export const getProducts = async () => {
    try {
        const response = await api.get('/products');
        return response;
    } catch (error) {
        console.error('Get products error:', error);
        throw error;
    }
};




// Cart functions
export const addToCart = async (data) => {
    try {
        console.log('Raw cart payload:', data);
        const response = await api.post('/cart/add', data);
        console.log('Cart response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Cart error:', {
            message: error.message,
            status: error.response?.status,
            data: error.response?.data
        });
        throw error;
    }
};

export const getCart = async () => {
    try {
        const response = await api.get('/cart');
        return response.data;
    } catch (error) {
        console.error("Cart error details:", error.response?.data);
        throw error;
    }
};

export const resetCart = async () => {
    try {
        const response = await api.post('/cart/reset', {});
        return response.data;
    } catch (error) {
        console.error('Error resetting cart:', error);
        throw error;
    }
};

export const updateCartItem = async (productId, quantity) => {
    try {
        const response = await api.put(`/cart/${productId}`, {quantity});
        return response.data;
    } catch (error) {
        console.error('Update cart error:', error);
        throw error;
    }
};

export const removeCartItem = async (productId) => {
    try {
        const response = await api.delete(`/cart/${productId}`);
        return response.data;
    } catch (error) {
        console.error('Remove from cart error:', error);
        throw error;
    }
};

// Other functions
export const getCategories = async () => {
    try {
        const response = await api.get('/categories');
        return response.data;
    } catch (error) {
        console.error('Get categories error:', error);
        throw error;
    }
};

// Admin Products API - Now using the interceptor
export const getAdminProducts = () => api.get('/admin/products');
export const createProduct = (productData) => api.post('/admin/products', productData);
export const updateProduct = (productId, productData) => api.put(`/admin/products/${productId}`, productData);
export const deleteProduct = (productId) => api.delete(`/admin/products/${productId}`);
export const getProduct = (id) => api.get(`/products/${id}`);

// Admin Orders API - Now using the interceptor
export const getAdminOrders = () => api.get('/admin/orders');
export const getOrderDetails = (orderId) => api.get(`/admin/orders/${orderId}`);
export const updateOrderStatus = (orderId, statusData) => api.put(`/admin/orders/${orderId}`, statusData);



export const checkout = (shippingData) => api.post('/orders', shippingData);
export const getOrders = () => api.get('/orders');
export const verifyPayment = (paymentData) => api.post('/verify-payment', paymentData);
